import React from "react";
import { TbAddressBook, TbBookUpload, TbCalendarWeek, TbDoorExit, TbListDetails, TbReceiptRupee } from "react-icons/tb";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { EmployeeContextProvider } from "../../context/employee-context";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import {
  ContentForm,
  ContentLayout,
  ContentMenu,
  ContentWrapper,
} from "../style";
import EmployeeStickyProfileInfoHeader from "./employee-sticky-profile-info-header";
import { PiUserListBold } from "react-icons/pi";
const menuItems = [
  {
    icon: <TbAddressBook />,
    primaryText: "Personal Information",
    path: "/employee",
    shouldDisabledNewEmployeeAdd: false,
  },
  {
    icon: <TbBookUpload />,
    primaryText: "Statutory & KYC",
    shouldDisabledNewEmployeeAdd: true,
    path: "/employee/statutoryKyc",
  },
  {
    icon: <TbReceiptRupee />,
    primaryText: "Pay & Benefits",
    shouldDisabledNewEmployeeAdd: true,
    path: "/employee/PayAndBenefits",
  },
  // {
  //   icon: <TbReceiptRupee />,
  //   primaryText: "Pay & KYC",
  //   shouldDisabledNewEmployeeAdd: true,
  //   path: "/employee/pay-kyc",
  // },
  {
    icon: <TbCalendarWeek />,
    primaryText: "Weekly Off",
    shouldDisabledNewEmployeeAdd: true,
    path: "/employee/weekly-off",
  },
  {
    icon: <TbListDetails />,
    primaryText: "Beneficiary",
    shouldDisabledNewEmployeeAdd: true,
    path: "/employee/beneficiary",
  },
  {
    icon: <PiUserListBold />,
    primaryText: "Family Details",
    shouldDisabledNewEmployeeAdd: true,
    path: "/employee/family-info",
  },

  {
    icon: <TbDoorExit />,
    primaryText: "exit formalities",
    shouldDisabledNewEmployeeAdd: true,
    path: "/employee/exit-formaliti",
  },
];
function Employee() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: employeeId } = useParams()
  return (<>
    <EmployeeContextProvider>
      <ContentLayout>
        <EmployeeStickyProfileInfoHeader />
        <ContentWrapper>
          <ContentMenu>
            <List
              size={"md"}
              color={"default"}
              activeColor={"default"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => {
                    {
                      if (employeeId) {
                        navigate(item.path === "" ? `${employeeId}` : `${item.path}/${employeeId}`)
                      }
                    }
                  }}
                  disabled={!employeeId && item.shouldDisabledNewEmployeeAdd}
                  className={location.pathname === item.path ? "active" : ""}
                  isActive={location.pathname === item.path} // Set isActive to true if paths match
                  colorVariant="light"
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>
          </ContentMenu>
          <ContentForm>
            <Outlet />
          </ContentForm>
        </ContentWrapper>
      </ContentLayout>
    </EmployeeContextProvider>
  </>
  );
}
export default Employee;
